module.exports = __webpack_public_path__ + "static/media/feedback-meeting.0c3e73e7.svg";